export const stateRestart = (elements) => {
    Object.keys(elements).forEach( item => {
        elements[item].isError = false;
        if(elements[item].elementType === "date") elements[item].value = new Date();
        else if(elements[item].elementType === "radio") elements[item].value = elements[item].value;
        else elements[item].value = ""
    })

    return elements;
}